<div class="ellipsis-cell" *ngIf="text" (mouseenter)="onEnter()" (mouseleave)="onLeave()">
  <p #txt class="ellipsis-text">{{ text }}</p>
  <span *ngIf="showTooltip"
        class="ellipsis-tooltip"
        [style.top.px]="tooltipTop"
        [style.left.px]="tooltipLeft">{{ text }}</span>
</div>
